"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
require.context("../../images", true);
import "src/decidim/iframe_settings_proposal_component";
import "src/decidim/global_adjustments";
document.addEventListener("DOMContentLoaded", function(event) {
  setTimeout(function() {
    const container = document.querySelector("div.proposal_custom_field div.editor-container[type=richtext]") || document.querySelector("div.editor div.editor-container");
    const editorToolbarImage = document.querySelector('div.editor-toolbar button[data-editor-type="image"]');
    if (container && editorToolbarImage) {
      let showEditorError2 = function(message) {
        const existingError = document.querySelector("div.custom-editor-upload-error");
        if (existingError) {
          existingError.remove();
        }
        const errorDiv = document.createElement("div");
        errorDiv.classList.add("custom-editor-upload-error", "form-error", "is-visible");
        errorDiv.textContent = message;
        let div = document.querySelector("div.proposal_custom_field div.editor-container[type=richtext]") || document.querySelector("div.editor div.editor-container");
        div.after(errorDiv);
      };
      var showEditorError = showEditorError2;
      const paragraph = document.createElement("p");
      paragraph.style.fontSize = "14px";
      paragraph.style.textAlign = "justify";
      paragraph.style.color = "rgb(62 76 92 / var(--tw-text-opacity, 1))";
      const lang = document.querySelector("html").lang;
      let text;
      switch (lang) {
        case "fr":
          text = "Si vous ajoutez une image, le nom du fichier ne doit pas contenir de caract\xE8res sp\xE9ciaux (espace, accent, parenth\xE8se...).";
          break;
        case "de":
          text = "Wenn Sie ein Bild hinzuf\xFCgen, darf der Dateiname keine Sonderzeichen (Leerzeichen, Akzente, Klammern...) enthalten.";
          break;
        case "nl":
          text = "Als je een afbeelding toevoegt, mag de bestandsnaam geen speciale tekens bevatten (spaties, accenten, haakjes...).";
          break;
        default:
          text = "If you upload an image, the name of the file must not contain special characters (space, accent, parenthesis...).";
      }
      paragraph.textContent = text;
      container.before(paragraph);
      const modalText = document.querySelector("div.upload-modal .upload-modal__text ul");
      const li = document.createElement("li");
      let liText;
      switch (lang) {
        case "fr":
          liText = "Pas de caract\xE8res sp\xE9ciaux dans le nom de l'image.";
          break;
        case "de":
          liText = "Keine Sonderzeichen im Bildnamen.";
          break;
        case "nl":
          liText = "Geen speciale tekens in de afbeeldingsnaam.";
          break;
        default:
          liText = "No special characters in image name.";
      }
      li.textContent = liText;
      modalText.appendChild(li);
      const originalFetch = window.fetch;
      window.fetch = function(...args) {
        return __async(this, null, function* () {
          var _a;
          const response = yield originalFetch.apply(this, args);
          const url = typeof args[0] === "string" ? args[0] : (_a = args[0]) == null ? void 0 : _a.url;
          if (url && url.includes("editor_images")) {
            if (response.status === 422) {
              const cloned = response.clone();
              cloned.json().then((data) => {
                showEditorError2(data.message);
              });
            } else if (response.ok) {
              const existingError = document.querySelector(".custom-editor-upload-error");
              if (existingError) {
                existingError.remove();
              }
            }
          }
          return response;
        });
      };
    }
  }, 500);
});
